/* eslint-disable */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Form, Button, DatePicker, Checkbox, Spin, message, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { DATE_FORMAT_FILTER_COLUMN } from 'utils/date';
import { CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { InfoCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { base64toBlob } from 'utils/file';
import { downloadExcelAccesosRol, downloadExcelUsuariosRol } from 'actions/cantidadUsuariosRol.actions';
import { selectRepUsersRolState } from 'selectors/userRepRol.selectors';
import * as types from 'constants/usersActionTypes';
import './ModalCantidadUsuariosRol.scss';

const ModalCantidadUsuariosRol = ({ open, cerrarModalConteos }) => {
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const { loading } = useSelector(selectRepUsersRolState);
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;

 const descargaReportes = async () => {
      try 
    {
      const values = await form.validateFields();

      if((values.accesos === undefined || !values.accesos) && (values.usuarios === undefined || !values.usuarios) ){
        dispatch({ type: types.GET_USERS_NOT_LOADING }); 
        messageApi.open({
            type: 'error',
            content: 'Debes seleccionar al menos un reporte para descargar.'
            });
      }
      else if(values.accesos !== undefined && values.accesos && (values.usuarios === undefined || !values.usuarios) ){
         obtenExcelAccesosRol (values);
      }
      else if(values.usuarios !== undefined && values.usuarios && (values.accesos === undefined || !values.accesos) ){

        obtenExcelUsuariosRol (values);
      }
      else if(values.usuarios !== undefined && values.usuarios && values.accesos !== undefined && values.accesos ){
        obtenExcelAccesosRol (values);
        obtenExcelUsuariosRol (values);
      }
    } catch (error) {
       dispatch({ type: types.GET_USERS_NOT_LOADING });
    }
  };

  const obtenExcelAccesosRol = async (values) => {
    dispatch({ type: types.GET_USERS_LOADING });

    const { success, response } = await dispatch(
      downloadExcelAccesosRol(values.fechas[0].format('YYYYMMDD'), values.fechas[1].format('YYYYMMDD'))
    );

    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
        }
      }
    }
    dispatch({ type: types.GET_USERS_NOT_LOADING });
  };

const obtenExcelUsuariosRol = async (values) => {
    dispatch({ type: types.GET_USERS_LOADING });

    const { success, response } = await dispatch(
      downloadExcelUsuariosRol(values.fechas[0].format('YYYYMMDD'), values.fechas[1].format('YYYYMMDD'))
    );

    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
        }
      }
    }
    dispatch({ type: types.GET_USERS_NOT_LOADING });
  };

  const handleCerrar = () => {
    form.resetFields();
    cerrarModalConteos();
  };

  return (
    <div>
      {contextHolder}
      <Modal 
        footer={null}
        width="48em"
        style={{ height: '400px' }}
        open={open}
        onCancel={() => {
          handleCerrar();
        }}
        centered
        closable={false}>
        <Form
          layout="vertical"
          onFinish={descargaReportes}
          form={form}>
          <span className="box-gral-inicio">
            <Spin spinning={loading}>
            <br />
            <div className="message-label">
                <span style={{ marginLeft: '0.5rem' }}>
                <InfoCircleOutlined style={{ color: '#c12b7d', marginRight: '0.5rem' }} />
                </span>
                <span>
                Se descargará la cantidad de usuarios registrados y la cantidad de accesos por rol.
                </span>
                <br />
                <span style={{ marginLeft: '2.0rem' }}>
                Selecciona el rango de fechas que deseas consultar.
                </span>
            </div>
            <br />
            <br /> 
            <div className='repore-checkbox'>
              <Row gutter={24}>
                <Col xs={10}>
                    <Form.Item name="accesos" valuePropName="checked">
                        <Checkbox> Reporte de accesos </Checkbox> 
                    </Form.Item>
                </Col>
                <Col xs={14}>
                    <Form.Item name="usuarios" valuePropName="checked">
                        <Checkbox> Reporte de usuarios registrados </Checkbox>
                    </Form.Item>
                </Col>
              </Row>                
            </div>
            <span className="buscador-monitoreo-etiqueta">
                <span style={{ color: 'red' }}>&#42;</span>Fechas:
            </span>
            <Form.Item
                name="fechas"
                className="buscador-monitoreo-etiqueta"
                rules={[{ required: true, message: fieldMsgs.ERR_RANGE_DATE_FIELD_REQUIRED }]}>
                <RangePicker
                format={DATE_FORMAT_FILTER_COLUMN}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
                /> 
            </Form.Item>
              <div className="buttons-reportes-rol-gral">
                <Button type="primary" className="buttons-reportes-rol"  htmlType="submit" >
                  Generar 
                </Button>
              </div>
            </Spin>
          </span>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalCantidadUsuariosRol;

ModalCantidadUsuariosRol.propTypes = {
  open: PropTypes.bool.isRequired,
  cerrarModalConteos: PropTypes.func.isRequired
};
